/* eslint-disable indent,no-new,no-undef */
import './bootstrap.js'
import Vue from 'vue'
import App from './App'
import './main_styles.scss'
import 'trix/dist/trix.css'
import router from './router'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['trix-editor']

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js